// extracted by mini-css-extract-plugin
export var body = "_2o-1";
export var bodyPadded = "_2o-2";
export var chevron = "_2o-4";
export var chevronOpen = "_2o-5";
export var header = "_2o-0";
export var icon = "_2o-3";